import { getFirstNameOfUserFromCookie } from '../get-first-name-of-user-from-cookie';
import Button from '../../../Skapa/Button/Button';
import Text from '@ingka/text';
import styles from '../LoginModal.module.scss';
import { LogoutButton } from '../LogoutButton/LogoutButton';
import { PREFIX } from '../../../Skapa/constants/constants';
import { ProfilePagesUrls } from '../../../../utils/Urls';

import { useTranslation, Trans } from 'react-i18next';
import { getRetailUnitAndLanguage } from '../../../../network/utils/getRetailUnitAndLanguage';

function contactUsUrl() {
  const { retailUnit: ru, language: lc } = getRetailUnitAndLanguage();
  return `https://${globalThis.location.host}/${ru}/${lc}/customer-service/contact-us/`;
}

export const FailScreen = ({ retry, logout }: { retry: () => void; logout: () => void }) => {
  const { t } = useTranslation('profile');

  return (
    <div className={styles.missingMenu}>
      <Text prefix={PREFIX} tagName="h1" textStyle="Heading.XL">
        {t('oneWebAgent.menu.error.title', { name: getFirstNameOfUserFromCookie() ?? '' }).replaceAll(' ,', ',')}
      </Text>

      <Text prefix={PREFIX} tagName="p" textStyle="Body.M">
        <Trans
          i18nKey={'profile:oneWebAgent.menu.error.description'}
          components={{
            support: <a href={contactUsUrl()} />,
          }}
        />
      </Text>

      <div className={styles.missingMenuButtonGroup}>
        <Button type="primary" text={t('oneWebAgent.menu.retryButton.label')} onClick={retry} />
        <Button type="secondary" text={t('oneWebAgent.menu.goToAccountHome.label')} href={ProfilePagesUrls.home()} />
      </div>

      <LogoutButton standalone logout={logout} />
    </div>
  );
};
